<template>
  <v-expansion-panel v-bind="$attrs" v-model="panel">
    <v-expansion-panel-header class="mt-2">
      Control de Entregas
      <template v-slot:actions>
        <v-btn @click.native.stop="reloadCurrentTab()" icon small>
          <v-icon color="primary">mdi-reload</v-icon>
        </v-btn>
        <v-btn @click="$store.dispatch('deleteWindowByUuid', { uuid: win.uuid })" icon small>
            <v-icon color="error">mdi-close</v-icon>
        </v-btn>
      </template>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-card>
        <block v-if="loading"></block>
        
        <v-tabs v-model="activeTab" dark background-color="primary" icons-and-text>
          <v-tabs-slider color="red"></v-tabs-slider>
          <v-tab href="#tab-1">
            Pendientes de Entrega
            <v-icon>mdi-clock-outline</v-icon>
          </v-tab>
          <v-tab href="#tab-2">
            Productos Entregados
            <v-icon>mdi-check-circle</v-icon>
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="activeTab" touchless>
          <!-- Tab 1: Pendientes de Entrega -->
          <v-tab-item value="tab-1">
            <v-card flat class="pa-1 position-relative">
              <v-card class="pa-4 white component-v-card">
            <GeneralFilter 
              class="mt-0" 
              :breakline="true" 
              :filterEndpoint="$API.invoices.getPendingDeliveries" 
              :columnsFilterEndpoint="$API.invoices.getPendingDeliveries" 
              :search="{ ...this.filter, showAllRecords: this.showAllRecords }"
              :columns.sync="filterColumns"
              :advancedFilter="true"
              prefix-column
              @emptyFilter="clearFilter" 
              @filtered="filterHandler" 
              :isAutoScrolled="true"
              @loading="changeLoading"
              :showBranchSelector="true"
              :showAllRecordsToggle="true"
              :selectedBranch="selectedBranch"
              :branches="branches"
              :currentBranch="currentBranch"
              @onBranchChange="onBranchChange"
              :showAllRecords="showAllRecords"
              @onShowAllRecordsChange="onShowAllRecordsChange"
            >
              <DxDataGrid 
                :data-source="invoices" 
                key-expr="ID_Invoice" 
                @exporting="onExporting"
                :scrolling="{ useNative: true }"    
                :column-auto-width="true"
                :paging="{ enabled: false }" 
                style="max-height: 600px;"
              >
                <DxExport :enabled="true"/>
                <DxColumn :width="80" cell-template="show-template" caption=""></DxColumn>
                <DxColumn data-field="ID_Invoice" caption="ID" width="200px"></DxColumn>
                <DxColumn data-field="correlative" caption="Correlativo interno"></DxColumn>
                <DxColumn data-field="InvoiceDate" width="100px" caption="Fecha de la Factura"></DxColumn>
                <DxColumn data-field="InvoiceType" caption="Tipo de Documento"></DxColumn>
                <DxColumn data-field="InvoiceName" caption="Nombre legal"></DxColumn>
                <DxColumn data-field="InvoiceTotalPagarToShow" caption="Total de Factura"></DxColumn>
                <DxColumn data-field="InvoiceStatusDescription" caption="Forma de pago"></DxColumn>
                <DxColumn data-field="FeMhEstado" width="150px" caption="Estado"></DxColumn>
                
                <template #show-template="{data}">
                  <a href="#" class="mx-1" @click.prevent.stop="showInvoiceDetail(data)">
                    <v-icon color="primary">mdi-eye</v-icon>
                  </a>
                </template>
              </DxDataGrid>
            </GeneralFilter>
              </v-card>
            </v-card>
          </v-tab-item>

          <!-- Tab 2: Productos Entregados -->
          <v-tab-item value="tab-2">
            <v-card flat class="pa-1 position-relative">
              <v-card class="pa-4 white component-v-card">
            <GeneralFilter 
              class="mt-0" 
              :breakline="true" 
              :filterEndpoint="$API.invoices.getDeliveredProducts" 
              :columnsFilterEndpoint="$API.invoices.getDeliveredProducts" 
              :search="{ ...this.deliveredFilter, showAllRecords: this.showAllRecords }"
              :columns.sync="filterColumns"
              :advancedFilter="true"
              prefix-column
              @emptyFilter="clearDeliveredFilter" 
              @filtered="deliveredFilterHandler" 
              :isAutoScrolled="true"
              @loading="changeLoading"
              :showBranchSelector="true"
              :showAllRecordsToggle="true"
              :selectedBranch="selectedBranch"
              :branches="branches"
              :currentBranch="currentBranch"
              @onBranchChange="onBranchChange"
              :showAllRecords="showAllRecords"
              @onShowAllRecordsChange="onShowAllRecordsChange"
            >
              <DxDataGrid 
                :data-source="deliveredInvoices" 
                key-expr="ID_Invoice" 
                @exporting="onExportingDelivered"
                :scrolling="{ useNative: true }"    
                :column-auto-width="true"
                :paging="{ enabled: false }" 
                style="max-height: 600px;"
              >
                <DxExport :enabled="true"/>
                <DxColumn :width="80" cell-template="show-template" caption=""></DxColumn>
                <DxColumn data-field="ID_Invoice" caption="ID" width="200px"></DxColumn>
                <DxColumn data-field="correlative" caption="Correlativo interno"></DxColumn>
                <DxColumn data-field="InvoiceDate" width="100px" caption="Fecha de la Factura"></DxColumn>
                <DxColumn data-field="InvoiceType" caption="Tipo de Documento"></DxColumn>
                <DxColumn data-field="InvoiceName" caption="Nombre legal"></DxColumn>
                <DxColumn data-field="InvoiceTotalPagarToShow" caption="Total de Factura"></DxColumn>
                <DxColumn data-field="InvoiceStatusDescription" caption="Forma de pago"></DxColumn>
                <DxColumn data-field="FeMhEstado" width="150px" caption="Estado"></DxColumn>
                
                <template #show-template="{data}">
                  <a href="#" class="mx-1" @click.prevent.stop="showInvoiceDetail(data)">
                    <v-icon>mdi-eye</v-icon>
                  </a>
                </template>
              </DxDataGrid>
            </GeneralFilter>
              </v-card>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-expansion-panel-content>

    <!-- Modal de Detalles de Entrega -->
    <PendingDeliveryDetails
      v-if="selectedInvoiceId"
      :invoiceId="selectedInvoiceId"
      :filteredWarehouse="getFilteredWarehouse()"
      @close="selectedInvoiceId = null"
      @deliveryUpdated="handleDeliveryUpdated"
    />
  </v-expansion-panel>
</template>

<script>
import Block from "@/components/Block";
import GeneralFilter from "@/components/GeneralFilter";
import PendingDeliveryDetails from "@/components/Panels/PendingDeliveryDetails";
import { DxDataGrid, DxColumn, DxExport } from "devextreme-vue/data-grid";
import { Workbook } from "exceljs";
import { saveAs } from "file-saver-es";
import { exportDataGrid } from "devextreme/excel_exporter";

export default {
  name: "PendingDeliveriesPanel",
  props: {
    win: {
      type: Object,
      required: true
    }
  },
  components: {
    Block,
    GeneralFilter,
    PendingDeliveryDetails,
    DxDataGrid,
    DxColumn,
    DxExport
  },
  data() {
    return {
      panel: 0,
      activeTab: null,
      loading: false,
      invoices: [],
      deliveredInvoices: [],
      isFiltered: false,
      isDeliveredFiltered: false,
      showAllRecords: false,
      selectedBranch: null,
      branches: [],
      currentBranch: null,
      warehouses: [],
      selectedWarehouse: null,
      selectedInvoiceId: null,
      filter: {
        codPointSale: localStorage.getItem("codPointSale"),
        ID_Branch: JSON.parse(localStorage.getItem("user")).branch || "",
        ID_Business: JSON.parse(localStorage.getItem("user")).businessid || "",
        user: JSON.parse(localStorage.getItem("user")).id || "",
        status: 1,
        istemplate: 0,
        typeData: "01",
        showFNS: this.$store.getters['rolesUser/getCustomRole'](247) ? true : false,
        showInvalid: false,
        showRejected: false,
        showContingency: false,
        showProcessed: true
      },
      deliveredFilter: {
        codPointSale: localStorage.getItem("codPointSale"),
        ID_Branch: JSON.parse(localStorage.getItem("user")).branch || "",
        ID_Business: JSON.parse(localStorage.getItem("user")).businessid || "",
        user: JSON.parse(localStorage.getItem("user")).id || "",
        status: 1,
        istemplate: 0,
        typeData: "01",
        showFNS: this.$store.getters['rolesUser/getCustomRole'](247) ? true : false,
        showInvalid: false,
        showRejected: false,
        showContingency: false,
        showProcessed: true
      },
      filterColumns: [
        {
          name: "BH.ID_Invoice",
          title: "ID de Factura",
          value: ""
        },
        {
          name: "CodigoGeneracion",
          title: "Código de generación",
          value: ""
        },
        {
          name: "NumeroControl",
          title: "Número de control",
          value: ""
        },
        {
          name: "InvoiceName",
          title: "Nombre Legal",
          value: ""
        },
        {
          name: "BH.Warehouse",
          title: "Bodega",
          value: "",
          type: "select",
          options: []
        },
        {
          name: "startDate",
          title: "Fecha Inicio",
          value: "",
          type: "date"
        },
        {
          name: "endDate",
          title: "Fecha Fin",
          value: "",
          type: "date"
        }
      ]
    };
  },
  mounted() {
    this.getBranches();
    this.getWarehouses();
    this.loadPendingDeliveries();
  },
  watch: {
    activeTab(newVal) {
      // Al cambiar de tab, cargar los datos correspondientes si no se han cargado
      if (newVal === 'tab-2' && this.deliveredInvoices.length === 0 && !this.isDeliveredFiltered) {
        this.loadDeliveredProducts();
      }
    }
  },
  methods: {
    reloadCurrentTab() {
      if (this.activeTab === 'tab-1' || this.activeTab === null) {
        this.loadPendingDeliveries();
      } else {
        this.loadDeliveredProducts();
      }
    },
    
    async loadPendingDeliveries() {
      this.loading = true;
      try {
        const filterWithLimit = {
          ...this.filter,
          showAllRecords: this.showAllRecords
        };
        
        const response = await this.$API.invoices.getPendingDeliveries(filterWithLimit);
        this.invoices = response || [];
      } catch (error) {
        console.error("Error al cargar facturas pendientes:", error);
        this.invoices = [];
      } finally {
        this.loading = false;
      }
    },
    
    async loadDeliveredProducts() {
      this.loading = true;
      try {
        const filterWithLimit = {
          ...this.deliveredFilter,
          showAllRecords: this.showAllRecords
        };
        
        const response = await this.$API.invoices.getDeliveredProducts(filterWithLimit);
        this.deliveredInvoices = response || [];
      } catch (error) {
        console.error("Error al cargar productos entregados:", error);
        this.deliveredInvoices = [];
      } finally {
        this.loading = false;
      }
    },
    
    filterHandler(response) {
      this.isFiltered = true;
      // Asegurar que se actualice reactivamente incluso con array vacío
      if (response && response.data) {
        this.invoices = [...response.data];
      } else if (Array.isArray(response)) {
        this.invoices = [...response];
      } else {
        this.invoices = [];
      }
    },
    
    deliveredFilterHandler(response) {
      this.isDeliveredFiltered = true;
      // Asegurar que se actualice reactivamente incluso con array vacío
      if (response && response.data) {
        this.deliveredInvoices = [...response.data];
      } else if (Array.isArray(response)) {
        this.deliveredInvoices = [...response];
      } else {
        this.deliveredInvoices = [];
      }
    },
    
    clearFilter() {
      this.isFiltered = false;
      this.loadPendingDeliveries();
    },
    
    clearDeliveredFilter() {
      this.isDeliveredFiltered = false;
      this.loadDeliveredProducts();
    },
    
    changeLoading(value) {
      this.loading = value;
    },
    
    onShowAllRecordsChange(value) {
      this.showAllRecords = value;
      if (!this.isFiltered) {
        this.loadPendingDeliveries();
      }
    },
    
    getBranches() {
      this.$API.branches
        .findBranches(JSON.parse(localStorage.getItem("user")).businessid)
        .then((data) => {
          this.branches = data;
          
          // Establecer la sucursal del localStorage como seleccionada por defecto
          const currentUserBranch = JSON.parse(localStorage.getItem("user")).branch || "";
          this.selectedBranch = currentUserBranch;
          this.filter.ID_Branch = currentUserBranch;
          
          // Obtener el nombre de la sucursal actual
          const currentBranchData = data.find(branch => branch.ID_Branch == currentUserBranch);
          if (currentBranchData) {
            this.currentBranch = currentBranchData.BranchName;
          }
        })
        .catch((err) => {
          console.log("Error al obtener sucursales:", err);
        });
    },
    
    getWarehouses() {
      const idbusiness = JSON.parse(localStorage.getItem("user")).businessid || "";
      const idbranch = JSON.parse(localStorage.getItem("user")).branch || "";
      
      this.$API.warehouse
        .getWarehouses({ 
          branch: idbranch, 
          business: idbusiness,
          notShowReserve: 1 
        })
        .then((response) => {
          this.warehouses = response;
          
          // Actualizar las opciones del filtro de bodega
          const warehouseFilterIndex = this.filterColumns.findIndex(col => col.name === "BH.Warehouse");
          if (warehouseFilterIndex !== -1) {
            this.filterColumns[warehouseFilterIndex].options = this.warehouses.map(wh => ({
              name: wh.Warehouse,
              value: wh.ID_Warehouse
            }));
          }
          
          // Establecer la bodega activa por defecto
          const activeWarehouse = this.warehouses.find(wh => wh.Active === true && wh.ID_Branch == idbranch);
          if (activeWarehouse) {
            this.selectedWarehouse = activeWarehouse.ID_Warehouse;
          }
        })
        .catch((err) => {
          console.log("Error al obtener bodegas:", err);
        });
    },
    
    onBranchChange(e) {
      this.selectedBranch = e;
      if (this.selectedBranch) {
        const selectedBranchData = this.branches.find(branch => branch.ID_Branch == this.selectedBranch);
        if (selectedBranchData) {
          this.currentBranch = selectedBranchData.BranchName;
        }
        this.filter.ID_Branch = this.selectedBranch;
      } else {
        // Si se limpia la selección, volver a la sucursal por defecto
        const defaultBranch = JSON.parse(localStorage.getItem("user")).branch || "";
        this.selectedBranch = defaultBranch;
        this.filter.ID_Branch = defaultBranch;
        
        const defaultBranchData = this.branches.find(branch => branch.ID_Branch == defaultBranch);
        if (defaultBranchData) {
          this.currentBranch = defaultBranchData.BranchName;
        }
      }
      
      // Recargar datos con la nueva sucursal
      if (!this.isFiltered) {
        this.loadPendingDeliveries();
      }
    },
    
    showInvoiceDetail(data) {
      this.selectedInvoiceId = data.data.ID_Invoice;
    },
    
    handleDeliveryUpdated() {
      // Recargar ambas listas para reflejar cambios en el estado de entrega
      this.loadPendingDeliveries();
      if (this.deliveredInvoices.length > 0 || this.isDeliveredFiltered) {
        this.loadDeliveredProducts();
      }
    },
    
    getFilteredWarehouse() {
      // Obtener la bodega seleccionada del filtro
      const warehouseFilter = this.filterColumns.find(col => col.name === "BH.Warehouse");
      return warehouseFilter && warehouseFilter.value ? warehouseFilter.value : null;
    },
    
    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("FacturasPendientesEntrega");

      exportDataGrid({
        component: e.component,
        worksheet,
        topLeftCell: { row: 4, column: 1 }
      }).then((cellRange) => {
        const headerRow = worksheet.getRow(2);
        headerRow.height = 30;
        worksheet.mergeCells(2, 1, 2, 8);

        headerRow.getCell(1).value = "Facturas Pendientes de Entrega";
        headerRow.getCell(1).font = { name: "Segoe UI Light", size: 22 };
        headerRow.getCell(1).alignment = { horizontal: "center" };

        const footerRowIndex = cellRange.to.row + 2;
        const footerRow = worksheet.getRow(footerRowIndex);
        worksheet.mergeCells(footerRowIndex, 1, footerRowIndex, 8);

        footerRow.getCell(1).value = "-";
        footerRow.getCell(1).font = { color: { argb: "BFBFBF" }, italic: true };
        footerRow.getCell(1).alignment = { horizontal: "right" };
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "FacturasPendientesEntrega.xlsx"
          );
        });
      });
      e.cancel = true;
    },
    
    onExportingDelivered(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("ProductosEntregados");

      exportDataGrid({
        component: e.component,
        worksheet,
        topLeftCell: { row: 4, column: 1 }
      }).then((cellRange) => {
        const headerRow = worksheet.getRow(2);
        headerRow.height = 30;
        worksheet.mergeCells(2, 1, 2, 8);

        headerRow.getCell(1).value = "Productos Entregados";
        headerRow.getCell(1).font = { name: "Segoe UI Light", size: 22 };
        headerRow.getCell(1).alignment = { horizontal: "center" };

        const footerRowIndex = cellRange.to.row + 2;
        const footerRow = worksheet.getRow(footerRowIndex);
        worksheet.mergeCells(footerRowIndex, 1, footerRowIndex, 8);

        footerRow.getCell(1).value = "-";
        footerRow.getCell(1).font = { color: { argb: "BFBFBF" }, italic: true };
        footerRow.getCell(1).alignment = { horizontal: "right" };
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "ProductosEntregados.xlsx"
          );
        });
      });
      e.cancel = true;
    }
  }
};
</script>

<style scoped>
.background {
  background-color: #f9f9f9;
  padding: 16px;
}

.component-v-card {
  border-radius: 15px;
}
</style>
